
import Vue from "vue";
import * as _ from "lodash";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";
import showService from "@/services/admin/showService";

export default Vue.extend({
  name: "RallyShowResultsEntry",
  components: {
    DatepickerFormatted
  },
  data: function() {
    return {
      showDeleteConfirmationDialog: false,
      deletedShowResultId: null,
      showResults: [] as any[],
      persistedShowResults: [] as any[],
      errorMessage: null as any,
      emptyRow: null as any,
    };
  },
  methods: {    
    emptyShowResultRow: function(lastPersistedRow: any, showResults: any[]){
      if(!lastPersistedRow){
        if(!!showResults && showResults.length > 0){
          lastPersistedRow = Object.assign({}, showResults[showResults.length - 1]);
        }
      }

      if(!!lastPersistedRow){
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: lastPersistedRow.showDate,
          judgeId: lastPersistedRow.judgeId,
          categoryId: lastPersistedRow.categoryId,
          divisionId: lastPersistedRow.divisionId,
          hit: null,
          place: null,
          score: null,
          showId: this.showId,
        };
      } else {
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: this.showInfo.defaultDate,
          categoryId: null,
          divisionId: null,
          judgeId: (!!this.showInfo.judges && this.showInfo.judges.length == 1) ? this.showInfo.judges[0].id : null,
          hit: null,
          place: null,
          score: null,
          showId: this.showId,
        };
      }
    },  
    reloadData: function() {
      if (this.showId) {
        this.$store.dispatch("changeLoaderStatus",true);

        showService
            .getShowResultsByShowId(this.showId, '')
            .then((res) => {
                this.showResults = _.cloneDeep(res);
                this.persistedShowResults = _.cloneDeep(res);
                this.emptyRow = Object.assign({}, this.emptyShowResultRow(null, res));
            })
            .catch((e) => console.log(e))
            .finally(() => { 
                this.$store.dispatch("changeLoaderStatus",false);
            }); 
      }
    }, 
    row_classes: function(item: any, index: number){
      if (!!item.resultId)
      {
        const index = this.showResults.findIndex(i => i.resultId === item.resultId);
        if(_.isEqual(this.showResults[index], this.persistedShowResults[index])){
          return '';
        }
      } 
      return 'orange  lighten-4';
    },
    saveShowResult: function(item: any, index: any) {
      this.$store.dispatch("changeLoaderStatus",true);
      const isAddingNewRow = !item.resultId;
      showService.updateShowResult(this.showId, 'R', item)
        .then((res) => {
          if(!res.success){
            this.errorMessage = res.messages.join(", ");
            if(isAddingNewRow){
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            }
          } else {
            if(isAddingNewRow){
              this.emptyRow.resultId = res.id;
              this.emptyRow.dogName = res.dogName;
              this.emptyRow.dogCallName = res.dogCallName;
              this.showResults.unshift(this.emptyRow);
              this.persistedShowResults = _.cloneDeep(this.showResults);

              this.emptyRow = Object.assign({}, this.emptyShowResultRow(this.emptyRow, this.showResults));
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            } else {
              //in case the dogId value has been changed we need to update the dog name to allow admin to validate data entry
              this.showResults[index].dogName = res.dogName;
              this.showResults[index].dogCallName = res.dogCallName;
              this.persistedShowResults = _.cloneDeep(this.showResults);
            }
            this.errorMessage = null;
          }
        })
        .catch((e) => {
          this.errorMessage = "Changes couldn't be saved. Ensure there are no validation errors before retrying.";
        })
        .finally(() => { this.$store.dispatch("changeLoaderStatus",false);}); 
    },
    deleteShowResult: function(item: any) {
      if(item.resultId) {//if that item has been persisted already
        this.deletedShowResultId = item.resultId;
        this.showDeleteConfirmationDialog = true;
      } else {
        const index = this.showResults.indexOf(item);
        this.showResults.splice(index, 1);
      }
    },
    confirmDelete: function() {
      showService.deleteShowResult(this.showId, this.deletedShowResultId)
      .then((res) => {
        if(!res.success){
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults[index].errors = res.messages.join(", ");
          this.deletedShowResultId = null;
        } else {
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults.splice(index, 1);
          this.persistedShowResults.splice(index, 1);
        }   
      })
      .finally(() => {this.showDeleteConfirmationDialog = false});
    },
    updateDates: function (val: any, key: string, item: any) {
      item[key] = val?.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, 'showResults', this.showResults);
    },
  },    
  created: function() {
    this.reloadData();
  },
  watch: {
    showId: function(newVal: String, oldVal: String) {
      if(newVal && newVal != oldVal){
        this.reloadData();
      }
    },
  },
  props: {
    showId: { type: String },
    showInfo: {type: Object}
  },
});
